import React, { useEffect, useState } from "react";
import API from "libs/api";
import { useParams } from "react-router-dom";
import TABLE from "components/cmp_table/cmp_table";



export default function TAB_HISTORY({ current_tab }) {

    //  variable declarations ------------------------------------------------------------------------------------------

    const { provider_id } = useParams();

    //  data table variables
    const [ var_data, set_data ] = useState([]);
    const [ var_data_settings, set_data_settings ] = useState({
        limit: 15,
        offset: 0,
        totalrows: 0,
        search: '',
        sortby: 'lastmodified',
        sortorder: 'desc'
    });
    const [ var_totalrows, set_totalrows ] = useState(0);

    //  data ready variables
    const [ var_ready, set_ready ] = useState(false);
    const [ var_processing, set_processing ] = useState('inactive');



    //  event listeners ------------------------------------------------------------------------------------------------

    useEffect(() => {
        if (current_tab === 'HISTORY' && provider_id) {
            get_transactions(var_data_settings);
        }
    }, [ current_tab, provider_id ]);



    //  async functions ------------------------------------------------------------------------------------------------

    async function get_transactions(data_settings){

        set_ready(false);
        set_processing('processing');

        //  use current data settings if none are submitted
        data_settings && set_data_settings(data_settings);
        let settings = data_settings || var_data_settings;

        try {
            let results = await API_get_transactions(settings);

            //  set totalrows
            set_totalrows(results.totalrows);

            //  set data
            set_data(results.results === undefined ? [] : results.results);

            set_processing('inactive');
            set_ready(true);
        } catch (e) {
            set_processing('error');
        }

    }



    //  API calls ------------------------------------------------------------------------------------------------------

    function API_get_transactions(settings){
        let var_parameters = {queryStringParameters: settings};
        return API.get('admin-providers', '/get-transactions/' + provider_id, var_parameters);
    }



    //  event functions ------------------------------------------------------------------------------------------------

    // function onClick_create(){
    //     set_location_create_open(true);
    // }

    function onClick_page(){

    }



    // RENDER CONTAINER ================================================================================================

    return (
        <div id='tab__page--provider_tags' className='tab__page tab__transition'>

            <div className='card history'>
                <div className='card__header'>
                    <div className='card__header__title_totalrows'>
                        <div className='text--md bold'>Provider history</div>
                        <div className='card__header__totalrows text--md normal'>{var_totalrows.toLocaleString()}</div>
                    </div>
                </div>
                <div className='card__content'>

                    <TABLE
                        var_data_settings={var_data_settings}
                        set_data_settings={set_data_settings}
                        onChange={get_transactions}
                        processing={var_processing}
                        totalrows={var_totalrows}
                    >
                        <headers>
                            <header sortby='lastmodified' width='192px'>Date</header>
                            <header sortby='description' >Description</header>
                            <header sortby='lastmodifiedby'>Modified by</header>
                        </headers>
                        <data>
                            {var_data.map(item =>
                                <row key={item.id} onClick={()=>onClick_page(item)}>
                                    <cell>{item.lastmodified}</cell>
                                    <cell>{item.description}</cell>
                                    <cell>{item.lastmodifiedby}</cell>
                                </row>
                            )}
                        </data>
                    </TABLE>

                </div>
            </div>
        </div>
    );
}
